module.exports = __webpack_public_path__ + "static/media/guide_1_m.ed242942.gif";